import React from 'react';

// Draft quality summary at the top of the generation report: one line per
// aspect, green / amber / red (grey = no data). The colours are decided on the
// server (draftQuality.QUALITY_THRESHOLDS), so they stay in one place.

const COLOURS = {
  green: { dot: 'var(--success)', bg: 'var(--success-light)', label: 'Good' },
  amber: { dot: 'var(--warning)', bg: 'var(--warning-light)', label: 'Check' },
  red: { dot: 'var(--danger)', bg: 'var(--danger-light)', label: 'Problem' },
  none: { dot: 'var(--border)', bg: 'var(--bg)', label: 'No data' },
};

export function QualitySummary({ lines }) {
  if (!Array.isArray(lines) || !lines.length) return null;
  return (
    <div style={{ marginBottom: '18px' }}>
      <p style={{ fontWeight: 600, fontSize: '0.88rem', margin: '0 0 8px' }}>Draft quality</p>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
        {lines.map((l) => {
          const c = COLOURS[l.colour] || COLOURS.none;
          return (
            <div
              key={l.key}
              style={{
                display: 'flex', alignItems: 'flex-start', gap: '10px', flexWrap: 'wrap',
                padding: '8px 12px', borderRadius: 'var(--radius)', background: c.bg, fontSize: '0.84rem',
              }}
            >
              <span
                aria-label={c.label}
                title={c.label}
                style={{ width: '10px', height: '10px', borderRadius: '50%', background: c.dot, flexShrink: 0, marginTop: '5px' }}
              />
              <span style={{ flex: '1 1 200px', minWidth: 0 }}>{l.label}</span>
              <strong style={{ flexShrink: 0 }}>{l.display}</strong>
              {l.names?.length > 0 && (
                <span style={{ flexBasis: '100%', paddingLeft: '20px', fontSize: '0.78rem', color: 'var(--text-light)' }}>
                  {l.names.join(', ')}
                </span>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default QualitySummary;
